import { PageWrapper } from "@/deps/ui-library";
import { PageHeader } from "@/components/PageHeader";
import { PeriodControlTab } from "./tabs/PeriodControlTab";

/** Monthly operational work, so it lives under Accounting (ADR-0028 rule 4). */
export function PeriodControlPage() {
  return (
    <PageWrapper spacing="md" className="p-0">
      <PageHeader title="Period control" />
      <PeriodControlTab />
    </PageWrapper>
  );
}
